<template>
  <div>
    <b-row class="row group-scoring__container-edit">
      <b-col cols="6">
        <span class="color-white fs-14">{{question.title}}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "ParticipantSectionResponse",
  data() {
    return {
      hasFieldError: false,
      fieldErrorText: ""
    };
  },
  props: {
    question: Object,
    surveyData: Object,
    mode: {
      default: 0
    },

    activityInfo: {
      default: () => {}
    }
  },
  methods: {
    roundOffToThreeDigits(value) {
      if (value) {
        const val = parseFloat(value).toFixed(1);
        return val > 0.0 ? val : 0;
      }
    }
  }
};
</script>

<style>
.group-scoring__container-edit {
  padding: 2px;
  border-radius: 3px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
}
</style>
